<template>
    <div id="app">
        <nav class="navbar navbar-expand-md navbar-light">
            <span class="navbar-brand mb-0 h1">Gestion des fournitures scolaires</span>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                    aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav mr-auto">
                        <li class="nav-item">
                            <router-link class="nav-link" v-bind:to="'/accueil'" routerLinkActive="active">Accueil</router-link>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">
                                Consulter
                            </a>
                            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                                <router-link class="dropdown-item" v-bind:to="'/inv-ele'">Inventaire d'un élève</router-link>
                                <router-link class="dropdown-item" v-bind:to="'/inv-ens'" v-if="utilisateur.type!='eleve'">Inventaire d'un enseignant</router-link>
                            </div>
                        </li>
                        <template v-if="utilisateur.type!='eleve'">
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">
                                    Distribuer
                                </a>
                                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <router-link class="dropdown-item" v-bind:to="'/distr-cla'">A une classe</router-link>
                                    <router-link class="dropdown-item" v-bind:to="'/distr-ele'">A un élève</router-link>
                                    <router-link class="dropdown-item" v-bind:to="'/distr-ens'" v-if="utilisateur.type=='administrateur'">A un enseignant</router-link>
                                </div>
                            </li>
                            
                            <template v-if="utilisateur.type=='administrateur'">
                            <li class="nav-item">
                                <router-link class="nav-link" v-bind:to="'/gerer-fourniture'" routerLinkActive="active">Fournitures</router-link>
                            </li>
                            <li class="nav-item" >
                                <router-link class="nav-link" v-bind:to="'/gerer-categorie'" routerLinkActive="active">Catégories</router-link>
                            </li>
                            </template>
                        </template>
                    </ul>
                    <p class="utilisateur">{{utilisateur.nom}}</p>
                    <a href="form_conn" class="btn btn-danger" role="button">Déconnexion</a>
                </div>
            </nav>
        <router-view/>
    </div>
</template>

<script>
import axios from 'axios'
import {ModelSelect} from 'vue-search-select'
import {globalStore} from './main.js'
export default  {
    name: 'App',
    data() {
        return {
            errors: [],
            utilisateur: globalStore.utilisateur
        }
    },
    methods: {

    },
    created() {
        this.$router.beforeEach((to, from, next) => {
            if (globalStore.enModification) {
                swal("Vous avez des modifications en cours, voulez-vous vraiment quitter cette page ?", {
                    icon: "warning",
                    dangerMode: true,
                    buttons: ["Annuler",true]
                }).then((continuer) => {
                    if (continuer) {
                        globalStore.enModification = false
                        next()
                    }
                })
            } else {
                next()
            }
            
        });
    }
}
</script>

<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

a > button {
   color: white;
}

input[type='number'] {
    -moz-appearance:textfield;
    margin: 0;
}

h1 {
    text-align: center;
    margin: 20px;
}

.navbar {
    background: lightgrey;
}

.search-icon {
    width: 18px;
}

.bottom-buffer {
    margin-bottom: 20px;
}

.utilisateur {
    margin: auto 10px;
}

.alignerDroite {
    text-align: right;
}

.alignerGauche {
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/App.vue